// noinspection ExceptionCaughtLocallyJS

import "./QRCodeButton.css";
import { IonButton, IonFab, IonIcon } from "@ionic/react";
import { qrCodeOutline } from "ionicons/icons";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setQRCode, setQRScannerStatus } from "../../../store/qrScanner";
import { setModalQrStatus } from "../../../store/supervisorRequiredDocuments";

// Importaciones correctas de Capacitor
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { App } from '@capacitor/app';

abstract class QR {
  static init() {
    let scanner = document.body.querySelector(".scanner-ui");
    // init view
    if (!scanner) {
      scanner = document.createElement("div");
      scanner.classList.add("scanner-ui");
      document.body.append(scanner);
      scanner.innerHTML = `
      <div id="qr-shaded-region">
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 40px; height: 5px; top: -5px; left: 0;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 40px; height: 5px; top: -5px; right: 0;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 40px; height: 5px; bottom: -5px; left: 0;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 40px; height: 5px; bottom: -5px; right: 0;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 5px; height: 45px; top: -5px; left: -5px;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 5px; height: 45px; bottom: -5px; left: -5px;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 5px; height: 45px; top: -5px; right: -5px;"></div>
        <div style="position: absolute; background-color: rgb(255, 255, 255); width: 5px; height: 45px; bottom: -5px; right: -5px;"></div>
      </div>
      `;
    }
  }

  static async start() {
    App.addListener("backButton", QR.stop);

    const status = await BarcodeScanner.checkPermission({ force: true });
    if (!status.granted) throw new Error("No se dieron permisos para leer QR");

    document.body.classList.add("qrscanner");
    await BarcodeScanner.hideBackground();

    return await BarcodeScanner.startScan({ targetedFormats: ["QR_CODE"] });
  }

  static async stop() {
    App.removeAllListeners();
    await BarcodeScanner.showBackground();
    await BarcodeScanner.stopScan();
    document.body.classList.remove("qrscanner");
  }

  static async scan() {
    try {
      QR.init();
      const result: any = await QR.start();
      await QR.stop();
      if (!result || !result.hasContent) throw new Error("Ha ocurrido un error leyendo QR");
      return result.content as string;
    } catch (err) {
      document.body.classList.remove("qrscanner");
      throw err;
    }
  }
}

export const QrCodeButton = ({ text }: { text: string }) => {
  const self = useRef({ dispatch: useDispatch() });

  useEffect(() => {
    self.current.dispatch(setQRScannerStatus("idle"));
    self.current.dispatch(setQRCode(""));
  }, []);

  const openScanner = async () => {
    self.current.dispatch(setQRScannerStatus("pending"));
    self.current.dispatch(setQRCode(""));
    try {
      const data = await QR.scan();
      self.current.dispatch(setQRScannerStatus("succeeded"));
      self.current.dispatch(setQRCode(data));
      self.current.dispatch(setModalQrStatus(true));
    } catch (error) {
      console.log("Error", error);
      self.current.dispatch(setQRScannerStatus("failed"));
      self.current.dispatch(setQRCode(""));
    }
  };

  return (
    <>
      <IonFab vertical="bottom" horizontal="end" slot="fixed" style={{ bottom: "8%", right: "3%" }}>
        <IonButton onClick={openScanner} color="secondary" size="large">
          <IonIcon icon={qrCodeOutline} slot="start" />
          <span> {text}</span>
        </IonButton>
      </IonFab>
    </>
  );
};
